var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "bread-crumb", staticClass: "yxtbiz-dept-tree-v3-bread-crumb" },
    _vm._l(_vm.breadCrumbAndTagList, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          class: {
            "yxtbiz-dept-tree-v3-bread-crumb-tag": item.type === "tag",
            "yxtbiz-dept-tree-v3-bread-crumb-item": item.type !== "tag",
          },
        },
        [
          item.type === "tag"
            ? _c("div", [_c("span", [_vm._v(">")])])
            : _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handle(item, index)
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }